
import { useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

export const useServiceImageHandler = (serviceId: string) => {
  const [serviceImages, setServiceImages] = useState<any[]>([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const fetchServiceImagesForPreview = async (serviceId: string) => {
    try {
      const { data: service, error: serviceError } = await supabase
        .from('services')
        .select('image_url')
        .eq('id', serviceId)
        .single();
      
      if (serviceError) {
        console.error('Error fetching service for preview:', serviceError);
        return [];
      }
      
      const { data: additionalImages, error: imagesError } = await supabase
        .from('service_images')
        .select('id, image_url, sequence')
        .eq('service_id', serviceId)
        .order('sequence', { ascending: true });
      
      if (imagesError) {
        console.error('Error fetching service images for preview:', imagesError);
        return [];
      }
      
      const allImages = [];
      
      if (service && service.image_url && service.image_url.trim() !== '') {
        allImages.push({
          id: 'cover',
          image_url: service.image_url
        });
      }
      
      if (additionalImages && additionalImages.length > 0) {
        const nonDuplicateImages = additionalImages.filter(
          img => !service || !service.image_url || img.image_url !== service.image_url
        );
        
        allImages.push(...nonDuplicateImages);
      }
      
      console.log(`Fetched ${allImages.length} images for service preview:`, allImages);
      return allImages;
    } catch (error) {
      console.error('Error in fetchServiceImagesForPreview:', error);
      return [];
    }
  };

  const handleImageNavigation = (direction: 'prev' | 'next') => {
    if (!serviceImages || serviceImages.length <= 1) return;
    
    if (direction === 'prev') {
      setSelectedImageIndex(prev => 
        prev === 0 ? serviceImages.length - 1 : prev - 1
      );
    } else {
      setSelectedImageIndex(prev => 
        prev === serviceImages.length - 1 ? 0 : prev + 1
      );
    }
  };

  const loadServiceImages = async (serviceId: string) => {
    if (serviceId) {
      const images = await fetchServiceImagesForPreview(serviceId);
      setServiceImages(images);
      setSelectedImageIndex(0);
    }
  };

  return {
    serviceImages,
    selectedImageIndex,
    loadServiceImages,
    handleImageNavigation
  };
};
